import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'if_wrkrs_are_paid_by_direct_deposit_into_a_bank_account_do_they'

export const dataPointDefinition = {
  retracedId: 'if_wrkrs_are_paid_by_direct_deposit_into_a_bank_account_do_they',
  name: 'If workers are paid by direct deposit into a bank account, do they have sole control of the bank account once opened?',
  description:
    '"Sole control of the account" refers to the fact that only the worker has control and access to the bank account. Management does not have any control or access.\r\r\n\r\r\nFor example, if the facility also has access to the worker\'s bank account any time after it has been opened, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-15--1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8660,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
